<template>
  <div class="sidebar">
    <ul class="side-nav">
      <li class="side-nav-link" :class="{'active' : currentPath == 'home'}">
        <FolderSVG/>
        <router-link
          :to="{ name: 'home'}"
        >
          <span v-if="isParent">Child Applications</span>
          <span v-else>My Applications</span>
        </router-link>
      </li>

      <li
        v-if="!isParent"
        class="side-nav-link"
        :class="{'active' : currentPath == 'archive-applications'}"
      >
        <TimeMachineSVG/>
        <router-link
          :to="{ name: 'archive-applications' }"
        ><span>Past Applications</span></router-link>
      </li>

      <li v-if="['parent', 'child'].includes(user.role)" class="side-nav-link"
          :class="{'active' : currentPath == 'family-list'}">
        <MemberAddSVG/>
        <router-link
          :to="{ name: 'family-list' }"
        ><span>Family</span></router-link>
      </li>

      <li class="side-nav-link" :class="{'active' : currentPath == 'tasks'}">
        <ReceiptListSVG/>
        <router-link
          :to="{ name: 'tasks' }"
        ><span>Tasks</span></router-link>
        <div
          v-if="toDoTasksCount"
          class="overdue-tasks"
        >{{ toDoTasksCount }}
        </div>
      </li>

      <li
        v-if="canManagePaymentPortal"
        class="side-nav-link"
        :class="{'active' : currentPath == 'payment-portal'}"
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9" cy="9" r="9" fill="#BA667C"/>
          <g clip-path="url(#clip0_1721_6241)">
            <path d="M8.99902 2.99902V14.999" stroke="white" stroke-width="1.4" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path
              d="M11.7256 5.18066H7.63468C7.12835 5.18066 6.64277 5.3818 6.28475 5.73982C5.92672 6.09785 5.72559 6.58343 5.72559 7.08975C5.72559 7.59608 5.92672 8.08166 6.28475 8.43969C6.64277 8.79771 7.12835 8.99885 7.63468 8.99885H10.362C10.8683 8.99885 11.3539 9.19998 11.7119 9.55801C12.0699 9.91603 12.271 10.4016 12.271 10.9079C12.271 11.4143 12.0699 11.8998 11.7119 12.2579C11.3539 12.6159 10.8683 12.817 10.362 12.817H5.72559"
              stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_1721_6241">
              <rect width="13.0909" height="13.0909" fill="white" transform="translate(2.45312 2.45312)"/>
            </clipPath>
          </defs>
        </svg>

        <router-link
          :to="{ name: 'payment-portal' }"
        ><span>Payment Portal</span></router-link>
      </li>
    </ul>

    <div class="user-info mobile-hidden">
      <div class="children__block-card-tight-details">
        <div class="user-info__avatar-wrapper">
          <BAvatar
            size="48"
            :src="user.avatar"
            :text="avatarText(user.fullName)"
            class="children__block-avatar"
          />
          <span class="avatar-status-dot"></span>
        </div>
        <h3 class="user-info__name">{{ user.fullName }}</h3>
      </div>
      <GearSVG class="user-settings"/>
    </div>
  </div>
</template>

<script>
import { getUserData } from '@/auth/utils'
import FolderSVG from '@/assets/images/icons/folder.svg'
import GearSVG from '@/assets/images/icons/gear.svg'
import MemberAddSVG from '@/assets/images/icons/member-add.svg'
import ReceiptListSVG from '@/assets/images/icons/receipt-list.svg'
import TimeMachineSVG from '@/assets/images/icons/time-machine.svg'
import { BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    FolderSVG,
    GearSVG,
    MemberAddSVG,
    ReceiptListSVG,
    TimeMachineSVG,
  },
  name: 'SideAccountNavigation',
  data: () => ({
    user: getUserData(),
    toDoTasksCount: 0,
    activePCCount: 0,
  }),
  computed:{
    currentPath() {
      return this.$route.name
    },
    isParent() {
      return this.user.role === 'parent'
    },
    canManagePaymentPortal() {
      if (!['parent', 'child'].includes(this.user.role)) {
        return false
      }

      if (!this.$ability.can('manage', 'Payment Portal')) {
        return false
      }

      if (this.$ability.can('manage', 'PaymentPortalRequirePC')) {
        return this.activePCCount > 0
      }

      return true
    }
  },
  async created() {
    await this.$store.dispatch('authSettings/fetchAuthUserBriefData', {
        with_to_do_tasks_counts: 1,
        with_active_pc_counts: 1,
    })
      .then(response => {
          this.toDoTasksCount = response.todo_tasks_count
          this.activePCCount = response.active_pc_count
      })
  },
  methods: {
    avatarText(value){
      if (!value) return ''
      const nameArray = value.split(' ')
      return nameArray.map(word => word.charAt(0).toUpperCase()).join('')
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/colors/colors';

.sidebar {
  position: sticky;
  top: 20px;
  left: 0;
  width: 320px;
  height: calc(100vh - 230px);
  border: 1px solid #eceff9;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.side-nav {
  padding: 20px;
  display: flex;
  flex-direction: column;
  &-link {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    & a, & svg > path, & svg > circle {
      color: $primary;
      fill: $primary;
    }
    &:hover a, &:hover svg > path, &:hover svg > circle {
      color: $primary;
      fill: $primary;
    }
    &.active a, &.active svg > path, &.active svg > circle{
      color: $primary;
      fill: $primary;
    }
    &.active {
      background-color: rgba($secondary, 0.1);
      border-radius: 8px;
    }

    svg {
      width: 29px;
      height: 28px;
      margin-right: 9px;
      flex-shrink: 0;
      display: block;
    }
  }
}
.user-info {
  //margin-top: 500px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__name {
    font-weight: 600;
    font-size: 16px;
    flex: 1;
  }

  &__avatar-wrapper {
    position: relative;
    display: inline-block;
  }

  .avatar-status-dot {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 12px;
    height: 12px;
    background-color: #28a745; /* зелёный */
    border: 2px solid white;   /* обводка, чтобы кружок отделялся от фона */
    border-radius: 50%;
  }
}

.overdue-tasks {
  margin-left: 10px;
  width: 16px;
  height: 16px;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  color: #fff;
  background: #B63D55;
  border-radius: 50%;
}

@media screen and (max-width: 767px) {
  .sidebar {
    position: static;
    width: auto;
    margin-bottom: 20px;
    height: 100%;
    .side-nav {
      margin: 15px 0;
      width: auto;
      height: auto;
      &-link:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
